import React from 'react'
export default function Header(){
    
    return (<div className='header'>
        <h2 style={{justifySelf:'center'}}>KUVA</h2>
    <p>Сайт Украiнського виробника взуття .</p>
    </div>)
    
}